module.exports = __webpack_public_path__ + "static/media/home.ca378a44.svg";